import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/app/StoreContext';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';

export const GuestRegistrationForm = observer(function GuestRegistrationForm() {
  const { auth } = useStore();
  const [nick, setNick] = useState('');

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await auth.registerGuest(nick);
      // Если в URL был ?join=CODE, HomePage сам перерисуется в AuthedHome
      // и его эффект уведёт на /join?code=CODE — это единственное место,
      // которое реально вызывает api.rooms.join (см. M01 в BUG-MULTIPLAYER-FLOW.md).
    } catch {
      // error displayed from store
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <Input
        label="Ник"
        placeholder="Как тебя называть?"
        value={nick}
        maxLength={16}
        onChange={(e) => setNick(e.target.value)}
        autoFocus
        error={auth.error ?? undefined}
      />
      <Button
        type="submit"
        loading={auth.isRegistering}
        disabled={!nick.trim()}
        style={{ marginTop: '12px', width: '100%' }}
      >
        Играть
      </Button>
    </form>
  );
});
